import React from 'react';

import { FileImage } from '@/common/constants';
import { ImgSquare,ImgThumbInner } from '@/components/controls/DropScan/ScanPreview/ScanPreview.styles';

import { ImageBlock, StackCard,StackedImageBlock } from './DocumentUploadCard.styles';

interface Props {
  files: FileImage[];
  onPreviewClick?: () => void;
}

const DocumentImagePreview: React.FC<Props> = ({ files, onPreviewClick }) => {
  const fileCount = files.length;
  const firstFile = files[0];

  const isTwoStack = fileCount === 2;
  const isThreeStack = fileCount >= 3;

  if (isThreeStack) {
    return (
      <StackedImageBlock onClick={onPreviewClick}>
        <StackCard
          layer={0}
          aria-hidden="true"
          pad="spacing4"
          round="fieldRound"
          border={{ color: 'border1', size: '1px' }}
          background="canvas"
        >
          <ImgThumbInner>
            <ImgSquare
              src={files[2].preview || files[2].url}
              alt=""
              style={{ objectFit: 'cover', objectPosition: 'top' }}
            />
          </ImgThumbInner>
        </StackCard>
        <StackCard
          layer={1}
          aria-hidden="true"
          pad="spacing4"
          round="fieldRound"
          border={{ color: 'border1', size: '1px' }}
          background="canvas"
        >
          <ImgThumbInner>
            <ImgSquare
              src={files[1].preview || files[1].url}
              alt=""
              style={{ objectFit: 'cover', objectPosition: 'top' }}
            />
          </ImgThumbInner>
        </StackCard>
        <StackCard
          layer={2}
          pad="spacing4"
          round="fieldRound"
          border={{ color: 'border1', size: '1px' }}
          background="canvas"
        >
          <ImgThumbInner>
            <ImgSquare
              src={firstFile.preview || firstFile.url}
              alt={firstFile.name || 'Document'}
              style={{ objectFit: 'cover', objectPosition: 'top' }}
            />
          </ImgThumbInner>
        </StackCard>
      </StackedImageBlock>
    );
  }

  if (isTwoStack) {
    return (
      <StackedImageBlock onClick={onPreviewClick}>
        <StackCard
          layer={1}
          aria-hidden="true"
          pad="spacing4"
          round="fieldRound"
          border={{ color: 'border1', size: '1px' }}
          background="canvas"
        >
          <ImgThumbInner>
            <ImgSquare
              src={files[1].preview || files[1].url}
              alt=""
              style={{ objectFit: 'cover', objectPosition: 'top' }}
            />
          </ImgThumbInner>
        </StackCard>
        <StackCard
          layer={2}
          pad="spacing4"
          round="fieldRound"
          border={{ color: 'border1', size: '1px' }}
          background="canvas"
        >
          <ImgThumbInner>
            <ImgSquare
              src={firstFile.preview || firstFile.url}
              alt={firstFile.name || 'Document'}
              style={{ objectFit: 'cover', objectPosition: 'top' }}
            />
          </ImgThumbInner>
        </StackCard>
      </StackedImageBlock>
    );
  }

  return (
    <ImageBlock
      onClick={onPreviewClick}
      pad="spacing4"
      round="fieldRound"
      border={{ color: 'border1', size: '1px' }}
      background="canvas"
    >
      <ImgThumbInner>
        <ImgSquare
          src={firstFile.preview || firstFile.url}
          alt={firstFile.name || 'Document'}
          style={{ objectFit: 'cover', objectPosition: 'top' }}
        />
      </ImgThumbInner>
    </ImageBlock>
  );
};

export default DocumentImagePreview;
